function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-8265 -6528)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3 -0.279)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8268 6597.279)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M108.8,0l36.268,63.228L108.8,126.457H36.268L0,63.228,36.268,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 37.42665100097656 1.999984741210938 L 2.3056640625 63.22826766967773 L 37.42665100097656 124.4565277099609 L 107.6461029052734 124.4565277099609 L 142.76708984375 63.22826766967773 L 107.6461029052734 1.999984741210938 L 37.42665100097656 1.999984741210938 M 36.26819610595703 -1.52587890625e-05 L 108.804557800293 -1.52587890625e-05 L 145.07275390625 63.22826766967773 L 108.804557800293 126.4565277099609 L 36.26819610595703 126.4565277099609 L 0 63.22826766967773 L 36.26819610595703 -1.52587890625e-05 Z",
  stroke: "none",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("text", {
  transform: "translate(8341 6631)",
  fill: "#fff",
  fontSize: 17,
  fontFamily: "Roboto-Bold, Roboto",
  fontWeight: 700,
  letterSpacing: "0.01em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -32.557,
  y: 0
}, "Acteurs "), /*#__PURE__*/React.createElement("tspan", {
  x: -50.322,
  y: 23
}, "pionniers de "), /*#__PURE__*/React.createElement("tspan", {
  x: -48.22,
  y: 46
}, "r\xE9emploi de "), /*#__PURE__*/React.createElement("tspan", {
  x: -39.055,
  y: 69
}, "mat\xE9riaux"))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.856 -0.817)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8385.144 6666.817)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M108.8,0l36.268,63.228L108.8,126.457H36.268L0,63.228,36.268,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 37.42665100097656 1.999984741210938 L 2.3056640625 63.22826766967773 L 37.42665100097656 124.4565277099609 L 107.6461029052734 124.4565277099609 L 142.76708984375 63.22826766967773 L 107.6461029052734 1.999984741210938 L 37.42665100097656 1.999984741210938 M 36.26819610595703 -1.52587890625e-05 L 108.804557800293 -1.52587890625e-05 L 145.07275390625 63.22826766967773 L 108.804557800293 126.4565277099609 L 36.26819610595703 126.4565277099609 L 0 63.22826766967773 L 36.26819610595703 -1.52587890625e-05 Z",
  stroke: "none",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("text", {
  transform: "translate(8458 6700)",
  fill: "#fff",
  fontSize: 17,
  fontFamily: "Roboto-Bold, Roboto",
  fontWeight: 700,
  letterSpacing: "0.01em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -32.557,
  y: 0
}, "Acteurs "), /*#__PURE__*/React.createElement("tspan", {
  x: -56.102,
  y: 23
}, "de l\u2019\xE9conomie "), /*#__PURE__*/React.createElement("tspan", {
  x: -29.98,
  y: 46
}, "sociale "), /*#__PURE__*/React.createElement("tspan", {
  x: -43.418,
  y: 69
}, "et solidaire"))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.077)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8385.923 6528)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 108.225341796875 125.4565505981445 L 36.84739303588867 125.4565505981445 L 1.152820944786072 63.22826766967773 L 36.847412109375 1.000007629394531 L 108.225341796875 1.000007629394531 L 143.9199371337891 63.22826766967773 L 108.225341796875 125.4565505981445 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 37.42665100097656 1.999984741210938 L 2.3056640625 63.22826766967773 L 37.42665100097656 124.4565277099609 L 107.6461029052734 124.4565277099609 L 142.76708984375 63.22826766967773 L 107.6461029052734 1.999984741210938 L 37.42665100097656 1.999984741210938 M 36.26819610595703 -1.52587890625e-05 L 108.804557800293 -1.52587890625e-05 L 145.07275390625 63.22826766967773 L 108.804557800293 126.4565277099609 L 36.26819610595703 126.4565277099609 L 0 63.22826766967773 L 36.26819610595703 -1.52587890625e-05 Z",
  stroke: "none",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("text", {
  transform: "translate(8458 6585)",
  fill: "#fff",
  fontSize: 17,
  fontFamily: "Roboto-Bold, Roboto",
  fontWeight: 700,
  letterSpacing: "0.01em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -32.557,
  y: 0
}, "Acteurs "), /*#__PURE__*/React.createElement("tspan", {
  x: -48.997,
  y: 23
}, "de r\xE9f\xE9rence"))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.193 -0.279)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8383.807 6804.279)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M108.8,0l36.268,63.228L108.8,126.457H36.268L0,63.228,36.268,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 37.42665100097656 1.999984741210938 L 2.3056640625 63.22826766967773 L 37.42665100097656 124.4565277099609 L 107.6461029052734 124.4565277099609 L 142.76708984375 63.22826766967773 L 107.6461029052734 1.999984741210938 L 37.42665100097656 1.999984741210938 M 36.26819610595703 -1.52587890625e-05 L 108.804557800293 -1.52587890625e-05 L 145.07275390625 63.22826766967773 L 108.804557800293 126.4565277099609 L 36.26819610595703 126.4565277099609 L 0 63.22826766967773 L 36.26819610595703 -1.52587890625e-05 Z",
  stroke: "none",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("text", {
  transform: "translate(8457 6848)",
  fill: "#fff",
  fontSize: 17,
  fontFamily: "Roboto-Bold, Roboto",
  fontWeight: 700,
  letterSpacing: "0.01em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -32.557,
  y: 0
}, "Acteurs "), /*#__PURE__*/React.createElement("tspan", {
  x: -59.93,
  y: 23
}, "professionnels "), /*#__PURE__*/React.createElement("tspan", {
  x: -48.486,
  y: 46
}, "du quotidien"))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.193 0.203)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8264.807 6872.797)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M108.8,0l36.268,63.228L108.8,126.457H36.268L0,63.228,36.268,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 37.42665100097656 1.999984741210938 L 2.3056640625 63.22826766967773 L 37.42665100097656 124.4565277099609 L 107.6461029052734 124.4565277099609 L 142.76708984375 63.22826766967773 L 107.6461029052734 1.999984741210938 L 37.42665100097656 1.999984741210938 M 36.26819610595703 -1.52587890625e-05 L 108.804557800293 -1.52587890625e-05 L 145.07275390625 63.22826766967773 L 108.804557800293 126.4565277099609 L 36.26819610595703 126.4565277099609 L 0 63.22826766967773 L 36.26819610595703 -1.52587890625e-05 Z",
  stroke: "none",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("text", {
  transform: "translate(8338 6920)",
  fill: "#fff",
  fontSize: 17,
  fontFamily: "Roboto-Bold, Roboto",
  fontWeight: 700,
  letterSpacing: "0.01em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -48.739,
  y: 0
}, "Acteurs n\xE9s "), /*#__PURE__*/React.createElement("tspan", {
  x: -47.245,
  y: 23
}, "d\u2019initiatives "), /*#__PURE__*/React.createElement("tspan", {
  x: -40.829,
  y: 46
}, "r\xE9gionales"))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1.47 -0.519)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8266.47 6735.519)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M108.8,0l36.268,63.228L108.8,126.457H36.268L0,63.228,36.268,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 37.42665100097656 1.999984741210938 L 2.3056640625 63.22826766967773 L 37.42665100097656 124.4565277099609 L 107.6461029052734 124.4565277099609 L 142.76708984375 63.22826766967773 L 107.6461029052734 1.999984741210938 L 37.42665100097656 1.999984741210938 M 36.26819610595703 -1.52587890625e-05 L 108.804557800293 -1.52587890625e-05 L 145.07275390625 63.22826766967773 L 108.804557800293 126.4565277099609 L 36.26819610595703 126.4565277099609 L 0 63.22826766967773 L 36.26819610595703 -1.52587890625e-05 Z",
  stroke: "none",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("text", {
  transform: "translate(8339 6764)",
  fill: "#fff",
  fontSize: 17,
  fontFamily: "Roboto-Bold, Roboto",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: -37.507,
  y: 0
}, "Initiatives"), /*#__PURE__*/React.createElement("tspan", {
  x: -52.673,
  y: 21
}, "remarquables"), /*#__PURE__*/React.createElement("tspan", {
  x: -37.117,
  y: 42
}, "ayant une"), /*#__PURE__*/React.createElement("tspan", {
  x: -24.96,
  y: 63
}, "port\xE9e"), /*#__PURE__*/React.createElement("tspan", {
  x: -35.415,
  y: 84
}, "nationale"))));

function SvgActorsResp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 266.072 471.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActorsResp);
export default __webpack_public_path__ + "static/media/actors_resp.70d2556c.svg";
export { ForwardRef as ReactComponent };